<!-- Desktop view -->
<div *appIsDesktop>
  @if (getNotificationIcon()) {
    <ds-button
      [id]="'notification-button-' + userIndex + '-' + itemIndex"
      size="medium"
      type="tertiary"
      [ngClass]="['notification-button', getNotificationIcon()]"
      variant="icon-only"
      [icon]="getNotificationIcon()"
      [matMenuTriggerFor]="notificationMenu"
      (click)="showNotification()"
      [isDisabled]="isDisabled"
      iconStyle="material-icons">
    </ds-button>
  }

  <mat-menu #notificationMenu="matMenu" class="tool-notifications-container" xPosition="before">
    @if (selectedNotification) {
      <div class="notification-popup" (click)="$event.stopPropagation()">
        <div [ngClass]="['notification-container', selectedNotification.type]">
          <div class="notification-header">
            <typography variant="body-1" weight="regular">{{ selectedNotification.title }}</typography>
          </div>
          @if (selectedNotification.description) {
            <typography variant="body-2">
              {{ selectedNotification.description }}
            </typography>
          }
          @if (selectedNotification.actions?.length) {
            <div class="notification-actions">
              @for (action of selectedNotification.actions; track action) {
                <ds-button
                  [id]="'action-' + action + '-' + userIndex + '-' + itemIndex"
                  [label]="action"
                  type="primary"
                  variant="label-only"
                  size="medium"
                  [isDisabled]="isDisabled"
                  (onClick)="handleAction(action)">
                </ds-button>
              }
            </div>
          }
        </div>
      </div>
    }
  </mat-menu>
</div>

<!-- Mobile view -->
<div *appIsMobile>
  @if (currentNotification) {
    <div>
      <ds-divider></ds-divider>
      <div class="mobile-notification">
        <ds-icon [icon]="getNotificationIcon()" [ngClass]="['notification-icon-mobile', getNotificationIcon()]" id="'notification-icon-' + userIndex + '-' + itemIndex">
        </ds-icon>
        <typography variant="button-3" weight="medium" id="'notification-title-' + userIndex + '-' + itemIndex">
          {{ currentNotification.title }}
        </typography>
      </div>
    </div>
  }
</div>
